import { Component, Host, h, Prop, Event, EventEmitter, Element } from '@stencil/core';
import { remCalc } from '../../style';

@Component({
  tag: 'rcm-accordeon',
  styleUrl: 'rcm-accordeon.scss',
  shadow: true,
})
export class RcmAccordeon {
  @Element() element: HTMLElement;

  @Prop() public mainTitle = '';

  @Prop({ mutable: true }) expanded = true;

  @Prop() isArticle = false;

  @Prop() isSbComponent = false;

  @Event({ eventName: 'rcmAccordeonExpand' })
  private expandEvent: EventEmitter;

  private switchExpanded = () => {
    this.expanded = !this.expanded;
    this.expandEvent.emit(this.expanded);
  };

  componentDidRender() {
    if (this.isSbComponent) {
      const slotElements = this.element.shadowRoot
        .querySelector('slot')
        .assignedNodes({ flatten: true })
        .filter((node) => node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName.toLowerCase() === 'rcm-richtext');

      slotElements.forEach((element) => {
        const richTextElement = element as HTMLElement;
        richTextElement.style.marginTop = remCalc(30).toString().concat('rem');
        richTextElement.style.marginBottom = remCalc(24).toString().concat('rem');
        (richTextElement as any).color = '#373737';
      });
    }
  }

  render() {
    const accordeonId = `rcm-accordion-content-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    return (
      <Host
        style={{
          marginTop: this.isSbComponent ? 'var(--spacings-m)' : 'var(--spacings-l)',
        }}
        role="region"
        aria-labelledby={this.mainTitle}
      >
        <rcm-container fullWidth={this.isArticle}>
          <div class={`accordeon${this.isSbComponent ? '--article' : ''}  ${this.expanded ? 'is-expanded' : ''}`}>
            <button class="accordeon-header" onClick={this.switchExpanded} aria-expanded={String(this.expanded)} aria-controls={accordeonId}>
              <rcm-headline level={this.isSbComponent ? 3 : 2} headline={this.mainTitle} bold></rcm-headline>
              <rcm-icon
                icon={this.expanded ? 'chevron-up' : 'chevron-down'}
                height={this.isSbComponent ? '1.5rem' : '2rem'}
                container-width={this.isSbComponent ? '1.5rem' : '2rem'}
                container-height={this.isSbComponent ? '1.5rem' : '2rem'}
              />
            </button>
            <div class="accordeon-content" id={accordeonId} hidden={!this.expanded}>
              <slot />
            </div>
          </div>
        </rcm-container>
      </Host>
    );
  }
}
